if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onNavClick = this.onNavClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.addEventListener('click', this.onNavClick);
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
      }

      hide() {
        document.removeEventListener('keydown', this.onKeyDown);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.addEventListener('keydown', this.onKeyDown);
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      onNavClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        this.navigate(direction);
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.navigate(1);
        } else if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.navigate(-1);
        }
      }

      navigate(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;

        const activeIndex = items.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (activeIndex + direction + items.length) % items.length;
        this.setActiveMedia(items[nextIndex]);
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;

        this.mediaItems.forEach((element) => element.classList.remove('active'));
        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavVisibility();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia =
          this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`) || this.mediaItems[0];
        this.setActiveMedia(activeMedia);
      }

      updateNavVisibility() {
        const hasMultiple = this.mediaItems.length > 1;
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.hidden = !hasMultiple;
        });
      }
    }
  );
}
